import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import { clearMessage } from "../../actions/messages";


export function Alert(props) {

const status = useSelector(state => state.auth.status);
const [visibility, setVisibility] = useState("hidden");

useEffect(() => {
    setVisibility("visible")
    if (props.message.success || props.message.serverError) {
        setTimeout(() => setVisibility("hidden"), 3250);
        setTimeout(() => props.clearMessage(props.message.id), 3500);
    }
}, [])


const handleClick = () => {
    setVisibility("hidden");
    setTimeout(() => props.clearMessage(props.message.id), 250);
}

const warningLine = 
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FF0040" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line></svg>

const infoLine = 
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2E9AFE" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="8"></line></svg>

const successLine = 
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#31B404" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>

const type = props.message.error || props.message.serverError ? "warning" : (props.message.success ? "success" : "info");

    return (
        <div className={`alert-wrapper ${visibility}`}>
            <div className={`alert ${type}`}>
                    {(props.message.error || props.message.serverError) && warningLine}
                    {props.message.info && infoLine}
                    {props.message.success && successLine}
                <span style={{flex: "2 1 0%", lineHeight: "130%", color: "black"}}>
                    {props.message.serverError && props.message.serverError}
                    {props.message.error && props.message.error}
                    {props.message.info && props.message.info}
                    {props.message.success && props.message.success}
                </span>
                <button onClick={handleClick}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        width="24" 
                        height="24" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="#7D7C88" 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        style={{marginRight: "0px", minWidth: "24px"}}
                        >
                        <line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
            </div>
        </div>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps, {clearMessage})(Alert);



// // INFO
// <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2E9AFE" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="8"></line></svg>

// // WARNING
// <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FF0040" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line></svg>

// // SUCCESS
// <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#31B404" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>